import { useRealtime, type ConnectionState } from '../contexts/RealtimeContext';

interface ConnectionStatusProps {
  className?: string;
}

/**
 * Component that displays the real-time connection status.
 * Shows a colored dot with tooltip indicating the connection state.
 */
export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ className = '' }) => {
  const { connectionState } = useRealtime();

  const getStatusColor = (state: ConnectionState): string => {
    switch (state) {
      case 'connected':
        return 'bg-brand-confirm/100';
      case 'connecting':
      case 'reconnecting':
        return 'bg-brand-accent animate-pulse';
      case 'disconnected':
      default:
        return 'bg-white/40';
    }
  };

  const getStatusText = (state: ConnectionState): string => {
    switch (state) {
      case 'connected':
        return 'Aktualizacje na żywo aktywne';
      case 'connecting':
        return 'Łączenie...';
      case 'reconnecting':
        return 'Ponowne łączenie...';
      case 'disconnected':
      default:
        return 'Aktualizacje na żywo nieaktywne';
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`} title={getStatusText(connectionState)}>
      <div
        className={`w-2.5 h-2.5 rounded-full ${getStatusColor(connectionState)}`}
        role="status"
        aria-label={getStatusText(connectionState)}
      />
      <span className="text-xs text-white/70 hidden sm:inline">
        {connectionState === 'connected' ? 'Na żywo' : connectionState === 'disconnected' ? 'Offline' : '...'}
      </span>
    </div>
  );
};
